import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import Modal, { buttonClass, primaryButtonClass, inputClass } from 'features/dashboards/components/Modal';
import { shareDashboard, unshareDashboard } from 'features/dashboards/api/dashboardsApi';
import { errorText } from 'features/dashboards/format';

export default function ShareDialog({ team, dashboard, onChanged, onClose }) {
  const [token, setToken] = useState(dashboard.share?.token || null);
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(null);
  const url = token ? `${window.location.origin}/public/reports/${token}` : '';

  const act = async (fn) => {
    setBusy(true); setError(null);
    try { await fn(); onChanged?.(); } catch (e) { setError(errorText(e)); } finally { setBusy(false); }
  };
  const create = () => act(async () => { const r = await shareDashboard(team, dashboard.id); setToken(r.token); });
  const revoke = () => act(async () => { await unshareDashboard(team, dashboard.id); setToken(null); });
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch (_) { /* clipboard blocked */ }
  };

  return (
    <Modal title="Public link" onClose={onClose}>
      <div className="space-y-3 px-4 py-3">
        <p className="text-[12px] text-[color:var(--text-muted)]">Anyone with the link can view this report without signing in.</p>
        {error ? <div className="rounded-lg border border-[color:var(--feedback-error)] bg-[color:var(--feedback-error-bg)] px-3 py-2 text-[12px] text-[color:var(--feedback-error)]">{error}</div> : null}
        {token ? (
          <>
            <div className="flex items-center gap-1.5">
              <input className={inputClass} value={url} readOnly onFocus={(e) => e.target.select()} aria-label="Public link" />
              <button type="button" className={buttonClass} onClick={copy}>
                {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />} {copied ? 'Copied' : 'Copy'}
              </button>
            </div>
            <div className="flex justify-between">
              <button type="button" className={buttonClass} disabled={busy} onClick={create}>New link</button>
              <button type="button" className={`${buttonClass} text-[color:var(--feedback-error)]`} disabled={busy} onClick={revoke}>Turn off</button>
            </div>
          </>
        ) : (
          <button type="button" className={primaryButtonClass} disabled={busy} onClick={create}>Create link</button>
        )}
      </div>
    </Modal>
  );
}
